module.exports = __webpack_public_path__ + "img/05.3fadd988.png";